import { __awaiter } from "tslib";
import waitFor from "../../common/waitFor";
/**
 * Tracks using the native tracker in the Android app.
 *
 * @param method - The method (identical to utag).
 * @param utagData - The payload (identical to utag).
 * @param options - Options for the wait function.
 */
const trackWithAndroidTracker = (method, utagData, options) => __awaiter(void 0, void 0, void 0, function* () {
    const tracker = yield waitFor(() => { var _a; return (_a = window === null || window === void 0 ? void 0 : window.NativeTracker) === null || _a === void 0 ? void 0 : _a.postMessage; }, options);
    tracker(JSON.stringify({ type: method, payload: utagData }));
});
export default trackWithAndroidTracker;
//# sourceMappingURL=trackWithAndroidTracker.js.map